import Enterprise from '@/datatypes/enterprise';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class BillingProviderCustomer {
  public id: string;
  public name: string;
  public created: number;
  public delinquent: boolean;
  public email: string;
  public deleted = false;
  public enterprise = new Enterprise({});

  constructor(options) {
    this.id = options.id;
    this.name = options.name;
    this.created = options.created;
    this.delinquent = options.delinquent;
    this.email = options.email;
    if (options.deleted) {
      this.deleted = options.deleted;
    }
    if (options.enterprise) {
      this.enterprise = new Enterprise(camelcaseKeysDeep(options.enterprise));
    }
  }
}
